import { render, staticRenderFns } from "./FocusAreas.vue?vue&type=template&id=646f9ecb&scoped=true"
import script from "./FocusAreas.vue?vue&type=script&lang=ts"
export * from "./FocusAreas.vue?vue&type=script&lang=ts"
import style0 from "./FocusAreas.vue?vue&type=style&index=0&id=646f9ecb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646f9ecb",
  null
  
)

export default component.exports